import React, { useCallback, useEffect, useRef, useState } from 'react';
import { SafeAreaView, View, FlatList, ActivityIndicator, StyleSheet, TouchableOpacity } from 'react-native';
import CustomLabel from '../../../../components/CustomLabel/CustomLabel';
import { Card, ProgressBar, useTheme } from 'react-native-paper';
import CustomInput from '../../../../components/CustomInput';
import CustomButton from '../../../../components/CustomButton';
import Ionicons from "@react-native-vector-icons/ionicons/static";
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { showMessage } from "react-native-flash-message";
import { useTableHelper } from '../../../../hooks/useTableHelper';

const getTranslationFile = (language) => {
    console.log(language)
    switch (language) {
        case 'en':
            return require('../../../../translations/en/databaseTableMappings').default;
        case 'gr':
            return require('../../../../translations/gr/databaseTableMappings').default;
        default:
            return require('../../../../translations/en/databaseTableMappings').default;
    }
};

const ListView = React.memo(({ item, index, styles, handleEditPress, dataConstraints, handleDeleteBranch, t }) => {
    const [showAdditionalLocationInfo, setAdditionalLocationInfo] = useState(false);
    const onShowAdditionalLocationInfoPress = (item) => {
        setAdditionalLocationInfo(!showAdditionalLocationInfo)
    }
    const itemArray = Object.entries(item).filter(([key, value]) => key !== 'index');
    let overallIndex = 0;
    useEffect(() => {
        //TODO
    }, [showAdditionalLocationInfo])
    return (
        <View>
            <SafeAreaView>
                <SafeAreaView>
                    <SafeAreaView
                        style={[styles.row]}>
                        {itemArray.slice(0, 2).map(([key, dataValue]) => (
                            <>
                                <SafeAreaView
                                    style={itemArray.length <= 2 ? styles.row : styles.itemrow}>
                                    <CustomLabel
                                        value={key}
                                        type='SUBTITLENOFLEX' />
                                    <CustomInput
                                        value={dataValue}
                                        setValue={(e) => handleEditPress(index, item, key, e)}
                                        maxLen={dataConstraints?.data[overallIndex++]?.CHARACTER_MAXIMUM_LENGTH}
                                        type={"BRANCHES"}
                                    />
                                </SafeAreaView>
                            </>

                        ))}
                        <SafeAreaView style={[styles.itemrow]}>
                            {itemArray.length > 2 &&
                                <CustomButton
                                    iconName={!showAdditionalLocationInfo ? 'chevron-forward-outline' : 'chevron-down-outline'}
                                    onPress={() => {
                                        onShowAdditionalLocationInfoPress(item, item.index)
                                    }}
                                    text={t('common:additionalInfos')}
                                    show='PART'
                                    type='PART'
                                    textTop='0'
                                    sz={30} />
                            }
                            <CustomButton
                                iconName='trash-outline'
                                onPress={() => {
                                    handleDeleteBranch(item.index)
                                }}
                                show='PART'
                                type='PART'
                                textTop='0'
                                sz={30} />
                        </SafeAreaView>
                    </SafeAreaView>
                    {/* Conditionally render the remaining elements */}
                    {showAdditionalLocationInfo && (
                        <>
                            {itemArray.slice(2).map(([key, value], cellIndex) => {
                                if (cellIndex % 3 === 0) {
                                    const subArray = itemArray.slice(cellIndex + 2, cellIndex + 5);
                                    return (
                                        <SafeAreaView key={cellIndex} style={styles.row}>
                                            {subArray.map(([subKey, subValue], subCellIndex) => (
                                                <View
                                                    key={subCellIndex + cellIndex}
                                                    style={[
                                                        styles.item,
                                                        subArray.length < 3 ? styles.itemOneThird : {}
                                                    ]}
                                                >
                                                    <CustomLabel
                                                        value={subKey}
                                                        type='SUBTITLENOFLEX'
                                                    />
                                                    <CustomInput
                                                        value={subValue}
                                                        setValue={(e) => handleEditPress(index, item, subKey, e)}
                                                        maxLen={dataConstraints?.data[overallIndex++]?.CHARACTER_MAXIMUM_LENGTH}
                                                        type={"BRANCHES"}
                                                    />
                                                </View>
                                            ))}
                                        </SafeAreaView>
                                    );
                                }
                                return null;
                            })}
                        </>
                    )}
                </SafeAreaView>
            </SafeAreaView>
        </View >
    );
});

const TableComponent = (props) => {
    const {
        importedData, isLoading, setScreen, handleFileUpload, clearImportedData,
        mapDisplayNamesToActualColumnNames, dropdowns, dataConstraints, isUploading, progress, name
    } = props;
    const { rowAdd, rowEdit } = useTableHelper();
    const { colors } = useTheme();
    const styles = makeStyles(colors);
    const { t, i18n } = useTranslation();
    const [changes, setChanges] = useState({});
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const [importedExcelData, setImportedExcelData] = useState([]);
    const [noChangesData, setNoChangesData] = useState([]);
    const [isCompatibleData, setIsCompatibleData] = useState(true);
    const databaseTableMappings = getTranslationFile(i18n.language);
    const ref = useRef(null);
    let XLSX = require('xlsx');

    //#region UseEffect
    useEffect(() => {
        const transformed = mapDisplayNamesToActualColumnNames([importedData.data[0]], databaseTableMappings);
        if (!compareKeys(transformed, dataConstraints)) {
            setIsCompatibleData(false);
        }
        else {
            setIsCompatibleData(true);
            setNoChangesData([...importedData.data])
            setImportedExcelData([...importedData.data])
        }
    }, [])
    //#endregion

    //#region Handlers
    const handleEditPress = React.useCallback((index, item, key, value) => {
        console.log(index, item, key, value)
        rowEdit(index, item, key, value, changes, setChanges, importedExcelData, setImportedExcelData)
        console.log(importedExcelData)
        // if (!(index in changes)) {
        //     changes[index] = {};
        // }
        // changes[index][key] = value;
        // importedExcelData[index] = { ...importedExcelData[index], [key]: value }
    },[]);
    const handleCancelChanges = () => {
        setImportedExcelData([...noChangesData]);
        setChanges({})
    }
    const handleAddNewRow = () => {
        rowAdd(importedExcelData, setImportedExcelData, [], [], ref, t, [], [], changes, setChanges)
    }

    const handleDeleteBranch = (index) => {
        const filteredData = importedExcelData.filter(item => item.index !== index);
        let array = [...filteredData];
        setImportedExcelData(array);
    }
    //#endregion

    //#region Helpers
    const hasChanges = (array1, array2) => {
        const isObjectInArray = (obj, array) => {
            return array.some(item => {
                return Object.keys(obj).every(key => obj[key] === item[key]);
            });
        };
        const array2Values = Object.values(array2);
        return !array2Values.every(subArray => isObjectInArray(subArray, array1));
    };
    const updateArrayWithChanges = (array1, array2) => {
        const changesMap = new Map(Object.entries(array2));
        const updatedArray = array1.map((item) => {
            if (changesMap.has(item.index.toString())) {
                const changes = changesMap.get(item.index.toString());
                const updatedItem = { ...item };
                Object.entries(changes).forEach(([key, value]) => {
                    updatedItem[key] = value;
                });
                return updatedItem;
            }
            return item;
        });
        return updatedArray;
    };

    const showUnsavedChangesMessage = () => {
        return (
            <View
                style={styles.button}>
                <TouchableOpacity
                    onPress={() => {
                        // * Note: below styles do not seem to be working. Maybe investigate?
                        Swal.fire({
                            title: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:changeBranchesMessage')}</text>`,
                            icon: "warning",
                            showCancelButton: true,
                            reverseButtons: true,
                            cancelButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:cancel')}</text>`,
                            cancelButtonColor: '#d3d3d3',
                            confirmButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:confirmMessage')}</text>`,
                            confirmButtonColor: '#A0A2FF',
                        }).then((result) => {
                            if (result.isConfirmed) {
                                setHasUnsavedChanges(false);
                                handlePress(item, index);
                            };
                        });
                    }}>
                    <View>
                        <Ionicons name="trash-outline" size={20} />
                    </View>
                </TouchableOpacity>
            </View >
        )
    }
    const goBack = () => {
        return hasChanges(noChangesData, changes);
    }
    const scrollToTop = () => {
        ref.current?.scrollToOffset({ y: 0, animated: true })
    }
    // Function to create a new object with the same keys and empty values
    const createEmptyObject = (data) => {
        const columnNames = dataConstraints.data.map(column => t(`databaseTableMappings:${column.COLUMN_NAME}`, { returnObjects: true })?.displayName || column.COLUMN_NAME);
        const emptyBranch = {};

        // if user deleted all data, then use the columns from the data constraints var
        if (data.length === 0) {
            columnNames.forEach(column => {
                const columnName = column;
                if (dropdowns && dropdowns.hasOwnProperty(columnName)) {
                    emptyBranch[columnName] = '';
                } else {
                    emptyBranch[columnName] = '';
                }
            });
            emptyBranch.index = 0;
        } else {
            const dataObj = data[0];
            const dataMapped = mapDisplayNamesToActualColumnNames([dataObj], databaseTableMappings);
            const keys = Object.keys(dataObj); // keys of the columns the way user sees it (aliases of column names)
            const mappedKeys = Object.keys(dataMapped[0]); // actual column names

            keys.forEach((key, index) => {
                const correspondingKey = mappedKeys[index];
                if (dropdowns && dropdowns.hasOwnProperty(correspondingKey)) {
                    emptyBranch[key] = dataObj[key];
                } else {
                    emptyBranch[key] = '';
                }
            });
            emptyBranch.index = data.length;
        }

        return emptyBranch;
    };

    const compareKeys = (dataMapped, dataConstraints) => {
        const columnNames = dataConstraints.data.map(item => item.COLUMN_NAME);

        for (const obj of dataMapped) {
            const objKeys = Object.keys(obj);

            for (const columnName of columnNames) {
                if (!objKeys.includes(columnName)) {
                    return false;
                }
            }
        }

        // If all keys match, return true
        return true;
    };
    //#endregion

    //#region Excel Specific Functions
    const saveExcel = async (download = false) => {
        let excelDataWithChanges = importedExcelData;
        if (hasChanges(importedExcelData, changes)) {
            excelDataWithChanges = updateArrayWithChanges(importedExcelData, changes);
        }
        if (excelDataWithChanges.length === 0) {
            showMessage({
                message: t('common:noChanges'),
                type: "danger",
            });
            return;
        }
        excelDataWithChanges = excelDataWithChanges.map(item => {
            const { index, ...rest } = item; // Destructure to remove 'index'
            return rest; // Return the object without 'index'
        });
        return createExcel(excelDataWithChanges, download);
    }

    const createExcel = (data, download = false) => {
        const wb = XLSX.utils.book_new();

        const headers = Object.keys(data[0]);

        const rows = data.map(item => Object.values(item));

        const wsData = [headers, ...rows];

        const ws = XLSX.utils.aoa_to_sheet(wsData);

        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        const excelBinary = XLSX.write(wb, { type: 'binary', bookType: 'xlsx' });

        const item = {
            data: btoa(excelBinary),
            name: `${name}_export`,
            type: 'xlsx'
        };
        if (download)
            return downloadExcelFile(item).then(() => {
                setHasUnsavedChanges(false);
            });
        return btoa(excelBinary)
    };

    const downloadExcelFile = React.useCallback(async (item) => {
        // create blob
        const blobData = await fetch(`data:plain/text;base64,${item.data}`).then(res => {
            return res.blob();
        });
        // create download link
        const url = URL.createObjectURL(blobData);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
            'download',
            `${item.name}.${item.type}`,
        );
        // insert link on page
        document.body.appendChild(link);
        // start download
        link.click();
        // remove link
        link.parentNode.removeChild(link);

    }, []);
    //#endregion

    //#region Components


    const renderRows = React.useCallback((item, index) => {
        return (
            <Card
                style={[styles.cardStyle]} >
                <Card.Content>
                    <ListView item={item} index={index}
                        styles={styles}
                        handleEditPress={handleEditPress}
                        dataConstraints={dataConstraints}
                        handleDeleteBranch={handleDeleteBranch}
                        t={t}
                    />
                </Card.Content>
            </Card >
        )
    }, [importedExcelData]);
    //#endregion

    return (
        <>
            <SafeAreaView style={styles.mainView}>
                {isUploading ? (
                    <View style={{ flex: 1, justifyContent: 'center' }}>
                        <View style={styles.modalBackground}>
                            <View style={styles.activityIndicatorWrapper}>
                                <View style={{ marginBottom: '7%' }}>
                                    <CustomLabel
                                        value={t('common:hold')}
                                        type='SUBTITLE'
                                    />
                                </View>
                                <ProgressBar progress={progress / 100} style={styles.progressBar} />
                                <CustomLabel
                                    value={`${Math.round(progress)}%`}
                                    type='SUBTITLE'
                                />
                            </View>
                        </View>
                    </View>
                ) : (
                    <>
                        <SafeAreaView style={[styles.row, { flexDirection: 'row', alignItems: 'center' }]}>
                            <SafeAreaView style={{ flex: 1 }}>
                                {isCompatibleData &&
                                    <SafeAreaView style={{ flexDirection: 'row', justifyContent: 'flex-start', }}>
                                        <CustomButton
                                            text={t('common:add')}
                                            onPress={() => handleAddNewRow()}
                                            type="MASS_UPLOAD_ADD_DATA"
                                            iconName="add-circle-outline"
                                            show="MASS_UPLOAD_ADD_DATA"
                                            textTop="0"
                                            sz={20}
                                        />
                                        <CustomButton
                                            text={t('common:cancel')}
                                            onPress={() => handleCancelChanges()}
                                            type="MASS_UPLOAD_DELETE_DATA"
                                            iconName="close-circle-outline"
                                            show="MASS_UPLOAD_DELETE_DATA"
                                            textTop="0"
                                            sz={20}
                                        />
                                    </SafeAreaView>
                                }
                            </SafeAreaView>

                            <View style={{ flex: 1, justifyContent: 'center', }}>
                                <CustomLabel
                                    value={`File Name: ${name}`}
                                    type='MASS_UPLOAD_CENTER'
                                />
                            </View>
                            <SafeAreaView style={{ flex: 1, justifyContent: 'flex-end' }}>
                                <TouchableOpacity onPress={() => {
                                    if (goBack()) {
                                        Swal.fire({
                                            title: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:unsavedChangesMassUploadMessage')}</text>`,
                                            icon: "warning",
                                            showCancelButton: true,
                                            reverseButtons: true,
                                            cancelButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:cancel')}</text>`,
                                            cancelButtonColor: '#d3d3d3',
                                            confirmButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">${t('common:confirmMessage')}</text>`,
                                            confirmButtonColor: '#A0A2FF',
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                setScreen('MassUpload');
                                                clearImportedData();
                                            }
                                        })
                                    } else {
                                        setScreen('MassUpload');
                                        clearImportedData();
                                    }
                                }} style={styles.backButton}>
                                    <Ionicons name="arrow-back" size={30} color="black" />
                                </TouchableOpacity>
                            </SafeAreaView>

                        </SafeAreaView>

                        <SafeAreaView style={[styles.fullHeight, { width: '100%' }]}>
                            <SafeAreaView style={styles.dataSpace}>
                                {
                                    !isCompatibleData ?
                                        <CustomLabel
                                            value={t('common:incompatibleData')}
                                            type='NO_BRANCHES'
                                        /> : <FlatList
                                            data={importedExcelData}
                                            keyExtractor={(item, index) => `row-${item.index}`}
                                            renderItem={({ item, index }) => renderRows(item, index)}
                                            refreshing={isLoading}
                                            initialNumToRender={4}
                                            ref={ref}
                                            ListEmptyComponent={
                                                isLoading ? (
                                                    <ActivityIndicator animating={true} color="#0000ff" />
                                                ) : (
                                                    <CustomLabel
                                                        value={t('common:noDataFound')}
                                                        type='NO_BRANCHES'
                                                    />
                                                )
                                            }
                                        />
                                }
                            </SafeAreaView>
                            <SafeAreaView style={{ flexDirection: 'row', justifyContent: 'flex-end', width: '100%' }}>
                                <SafeAreaView style={{ width: '70%' }}>
                                    <SafeAreaView style={{ alignItems: 'flex-end' }}>
                                        <SafeAreaView style={[styles.halfColumn]}>
                                            <SafeAreaView style={styles.buttonRight}>
                                                {isCompatibleData &&
                                                    <>
                                                        <CustomButton
                                                            text={t('common:downloadAsExcel')}
                                                            onPress={() => saveExcel(download = true)}
                                                            type="BUTTON_SAVE"
                                                            iconName="download-outline"
                                                            show="BUTTON_SAVE"
                                                            textTop="0"
                                                            sz={20}
                                                        />
                                                        <CustomButton
                                                            text={t('common:importExcel')}
                                                            onPress={async () => {
                                                                saveExcel(download = false).then(async (base64) => {
                                                                    await handleFileUpload({ base64data: base64 }, isUpload = true)
                                                                })
                                                            }}
                                                            type="BUTTON_SAVE"
                                                            iconName="add-circle-outline"
                                                            show="BUTTON_SAVE"
                                                            textTop="0"
                                                            sz={20}
                                                        />
                                                    </>}
                                            </SafeAreaView>
                                        </SafeAreaView>
                                    </SafeAreaView>
                                </SafeAreaView>
                            </SafeAreaView>
                            {hasUnsavedChanges &&
                                <SafeAreaView style={styles.fullSpace}>
                                    {showUnsavedChangesMessage()}
                                </SafeAreaView>
                            }

                        </SafeAreaView>
                    </>
                )}
            </SafeAreaView>
        </>
    );
};

const makeStyles = (colors) => StyleSheet.create({
    cardStyle: {
        margin: 10,
        borderRadius: 5,
        elevation: 5,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.3,
        shadowRadius: 5,
        backgroundColor: colors.background_card,
    },
    item: {
        flex: 1,
    },
    buttonRight: {
        alignSelf: 'flex-end',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        width: '75%',
        // margin: 15,
    },
    buttonLeft: {
        alignSelf: 'flex-start',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        width: '75%',
        margin: 15,
    },
    alignedRight: {
        alignItems: 'flex-end',
        justifyContent: 'flex-end'
    },
    alignedLeft: {
        alignItems: 'flex-start',
        justifyContent: 'flex-start'
    },
    mainView: {
        height: '100%',
    },
    backButton: {
        alignSelf: 'flex-end'
    },
    itemrow: {
        flex: 1,
        flexDirection: 'row',
    },
    row: {
        flex: 1,
        margin: 10,
        flexDirection: "row",
        alignItems: 'center',
    },
    buttons: {
        width: '100%',

    },
    halfColumn: {
        width: '50%'
    },
    fullSpace: {
        width: '100%',
        height: '100%'
    },
    fullHeight: {
        height: '100%'
    },
    dataSpace: {
        height: '95%'
    },
    modalBackground: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: colors.background_card,
    },
    activityIndicatorWrapper: {
        height: 100,
        width: '50%',
        borderRadius: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 10,
    },
    progressBar: {
        width: '100%',
        height: 10,
        borderRadius: 5
    },
    progressText: {
        marginTop: 10,
        fontSize: 16,
    },
});

export default TableComponent;